import { useQuery } from '@tanstack/react-query'

import { MessagingQueryKey } from '../../keys'
import messagingService from '../services'

import type { GetMessagingAnalyticsParams } from '../../types'

export default function useQueryGetMessagingAnalytics(
	params: GetMessagingAnalyticsParams,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetMessagingAnalytics, params],
		queryFn: () => messagingService.getMessagingAnalytics(params),
	})
}
